/*****************************************
 * * IMPORTS
 *****************************************/
// React libraries
import React from 'react';

// styles and images
import styles from './Header.module.css';
import { aboutText } from './text';

// components

/*****************************************
 * * CREATE COMPONENT
 *****************************************/

function About() {


  return (
    <div className={styles.text}>
      {aboutText.map((el, idx) => {
        
        if (idx === 0) {
          return (
            <p key={idx} className={styles.textFirst}>
              {el}
            </p>
          );
        }
        return <p key={idx}>{el}</p>;
      })}
    </div>
  );
}

export default About;
